/* unplugin-vue-components disabled */import { render } from "./ScrollNumber.vue?vue&type=template&id=ce840e46&scoped=true"
import script from "./ScrollNumber.vue?vue&type=script&lang=js"
export * from "./ScrollNumber.vue?vue&type=script&lang=js"

import "./ScrollNumber.vue?vue&type=style&index=0&id=ce840e46&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce840e46"]])

export default __exports__